import ReactSlider from 'react-slider';
import styled from '@emotion/styled';
import { Flex, Button } from './shared';
import { theme } from '../design-system';
import blindSpotVideoSliderIcon from '../icons/blindspot-video-slider.svg';
import { calibrationConstants } from '../../../helpers/calibration-constants';
import { useCalibration } from '../../../context/calibrationContext';

const StyledBlindSpotSlider = styled(ReactSlider)`
  width: 100%;
  & .blindspot-slider-thumb {
    width: 1.5em;
    height: 1.5em;
    background: ${(props) => (props.videoSlider ? `url(${blindSpotVideoSliderIcon})` : '#000')};
    background-size: ${(props) => (props.videoSlider ? 'cover' : null)};
    cursor: pointer;
    border-radius: 50%;
    transform: translateY(-50%);
  }
`;

const BlindspotSliderContainer = styled(Flex)`
  width: 100%;
  height: 8vh;
  min-height: 40px;
  max-height: 60px;
  cursor: pointer;
  border: 1px solid ${theme.colors.primary};
  border-radius: 4px;
  padding: 0px 0.625rem;
  align-items: center;
`;

const BlindSpotSlider = ({ position, setPosition, videoSlider }) => {
  const { blindSpotThumbnailWidthPx } = calibrationConstants;
  const {
    calibrationData: { circleDimensionsPx, screenWidthPx },
  } = useCalibration();

  const handleBlindSpotMovement = (direction) => {
    if (direction === 'increment') {
      const incrementedValue = position + circleDimensionsPx;
      if (incrementedValue <= screenWidthPx - circleDimensionsPx) {
        setPosition(incrementedValue);
      } else setPosition(screenWidthPx - circleDimensionsPx);
    } else {
      const decrementedValue = position - circleDimensionsPx;
      if (decrementedValue >= 0) {
        setPosition(decrementedValue);
      } else setPosition(0);
    }
  };

  const getMaxValue = () => {
    return videoSlider ? screenWidthPx - blindSpotThumbnailWidthPx : screenWidthPx - circleDimensionsPx;
  };

  return (
    <Flex column centered>
      <Flex width='90vw' maxWidth='700px' centered>
        <Button
          borderRadius='50%'
          fontSize='1.5rem'
          width='3rem'
          padding='0'
          marginRight='1rem'
          onClick={() => handleBlindSpotMovement('decrement')}
          disabled={position <= 0}
        >
          {'\u003c'}
        </Button>
        <BlindspotSliderContainer>
          <StyledBlindSpotSlider
            circleDimensionsPx={circleDimensionsPx}
            value={position}
            min={0}
            max={getMaxValue()}
            onAfterChange={(newValue) => setPosition(newValue)}
            thumbClassName='blindspot-slider-thumb'
            videoSlider={videoSlider}
          />
        </BlindspotSliderContainer>

        <Button
          borderRadius='50%'
          fontSize='1.5rem'
          width='3rem'
          padding='0'
          marginLeft='1rem'
          onClick={() => handleBlindSpotMovement('increment')}
          disabled={position >= getMaxValue()}
        >
          {'\u003e'}
        </Button>
      </Flex>
    </Flex>
  );
};

export default BlindSpotSlider;
